
import { useState } from 'react';

export default function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('all');

  const projects = [
    {
      title: 'E-commerce de Moda',
      category: 'design',
      description: 'Diseño y desarrollo de tienda online con aumento del 250% en conversiones',
      image: 'https://public.readdy.ai/ai/img_res/e5304919ce5f29dbc9c9608e6eedabf4.jpg',
      results: '+250% conversiones',
      tags: ['Diseño Web', 'E-commerce', 'SEO']
    },
    {
      title: 'Campaña Meta Ads - Restaurante',
      category: 'ads',
      description: 'Estrategia de publicidad en redes sociales que generó 500+ reservas mensuales',
      image: 'https://readdy.ai/api/search-image?query=elegant%20restaurant%20social%20media%20advertising%20campaign%2C%20delicious%20gourmet%20food%20photography%2C%20modern%20dining%20experience%2C%20professional%20food%20styling%2C%20warm%20ambient%20lighting%2C%20clean%20white%20background&width=600&height=400&seq=portfolio2&orientation=landscape',
      results: '+500 reservas/mes',
      tags: ['Meta Ads', 'Redes Sociales', 'ROI 5x']
    },
    {
      title: 'Automatización - Inmobiliaria',
      category: 'automation',
      description: 'Sistema de automatización que redujo 70% el tiempo de gestión de leads',
      image: 'https://readdy.ai/api/search-image?query=modern%20real%20estate%20automation%20dashboard%20interface%2C%20property%20management%20system%2C%20clean%20professional%20design%2C%20data%20visualization%2C%20CRM%20interface%2C%20light%20background%2C%20business%20technology&width=600&height=400&seq=portfolio3&orientation=landscape',
      results: '-70% tiempo gestión',
      tags: ['Automatización', 'CRM', 'Chatbot']
    },
    {
      title: 'Branding - Startup Tech',
      category: 'design',
      description: 'Identidad visual completa y sitio web para startup tecnológica',
      image: 'https://readdy.ai/api/search-image?query=modern%20tech%20startup%20branding%20and%20website%20design%2C%20innovative%20technology%20company%20interface%2C%20futuristic%20clean%20design%2C%20professional%20corporate%20identity%2C%20minimalist%20aesthetic%2C%20light%20background&width=600&height=400&seq=portfolio4&orientation=landscape',
      results: 'Inversión $500K',
      tags: ['Branding', 'Diseño Web', 'UX/UI']
    },
    {
      title: 'Redes Sociales - Fitness',
      category: 'social',
      description: 'Gestión de redes sociales con crecimiento de 50K seguidores en 6 meses',
      image: 'https://readdy.ai/api/search-image?query=dynamic%20fitness%20social%20media%20content%2C%20energetic%20workout%20photography%2C%20healthy%20lifestyle%20branding%2C%20professional%20gym%20photography%2C%20motivational%20fitness%20content%2C%20clean%20bright%20background&width=600&height=400&seq=portfolio5&orientation=landscape',
      results: '+50K seguidores',
      tags: ['Instagram', 'TikTok', 'Contenido']
    },
    {
      title: 'Meta Ads - Educación Online',
      category: 'ads',
      description: 'Campaña publicitaria que generó 1,200 inscripciones con ROI de 8x',
      image: 'https://readdy.ai/api/search-image?query=modern%20online%20education%20platform%20advertising%2C%20e-learning%20course%20promotion%2C%20professional%20educational%20content%2C%20student%20success%20stories%2C%20clean%20academic%20design%2C%20bright%20background&width=600&height=400&seq=portfolio6&orientation=landscape',
      results: 'ROI 8x',
      tags: ['Meta Ads', 'Lead Generation', 'Embudo']
    }
  ];

  const filters = [
    { id: 'all', label: 'Todos' },
    { id: 'design', label: 'Diseño' },
    { id: 'ads', label: 'Publicidad' },
    { id: 'social', label: 'Redes Sociales' },
    { id: 'automation', label: 'Automatización' }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  return (
    <section id="portfolio" className="py-24 px-8 md:px-6 relative">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16 px-4 md:px-0">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Casos de Éxito</h2>
          <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto px-2">
            Proyectos que han transformado negocios y generado resultados reales
          </p>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-4 mb-12 px-4">
          {filters.map(filter => (
            <button
              key={filter.id}
              onClick={() => setActiveFilter(filter.id)}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeFilter === filter.id
                  ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg shadow-purple-500/30'
                  : 'bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white border border-white/10'
              }`}
            >
              {filter.label}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => (
            <div 
              key={index}
              className="group bg-white/5 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/10 hover:border-white/20 transition-all duration-300 hover:transform hover:scale-105 cursor-pointer"
            >
              <div className="relative overflow-hidden h-64">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/50 to-transparent opacity-60"></div>
                <div className="absolute top-4 right-4 bg-green-500 text-white px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap">
                  {project.results}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-3">{project.title}</h3>
                <p className="text-gray-400 mb-4 leading-relaxed">{project.description}</p>
                
                <div className="flex flex-wrap gap-2">
                  {project.tags.map((tag, idx) => (
                    <span 
                      key={idx}
                      className="px-3 py-1 bg-white/10 text-gray-300 rounded-full text-sm whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16 px-6 md:px-0">
          <p className="text-gray-400 text-base md:text-lg mb-6 px-4">
            ¿Quieres ser nuestro próximo caso de éxito?
          </p>
          <a 
            href="#contact"
            className="inline-block px-8 py-4 bg-gradient-to-r from-blue-500 to-purple-600 text-white font-semibold rounded-full hover:shadow-2xl hover:shadow-purple-500/50 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Iniciar Proyecto
          </a>
        </div>
      </div>
    </section>
  );
}
